import React from 'react';
import { PiChatsCircle, PiChatsCircleFill } from 'react-icons/pi';

type SvgRest = Omit<React.SVGProps<SVGSVGElement>, 'color' | 'fill' | 'strokeWidth' | 'ref'>;

interface MessagesIconProps extends SvgRest {
  size?: number;
  /** Active state — switches to the filled Phosphor variant. */
  active?: boolean;
  /** Stroke + body color. Defaults to currentColor so it inherits text color. */
  color?: string;
  ariaLabel?: string;
}

/**
 * "Messages" icon used across the sidebar, mobile bottom nav, and empty
 * states. Backed by Phosphor (`react-icons/pi`) — two stacked circular speech
 * bubbles signal a chat hub with multiple conversations.
 *
 * Regular weight is used for inactive states; the filled variant takes over on
 * the active route, providing clear visual feedback without changing size.
 */
const MessagesIcon: React.FC<MessagesIconProps> = ({
  size = 22,
  active = false,
  className = '',
  color,
  ariaLabel,
  ...rest
}) => {
  const Icon = active ? PiChatsCircleFill : PiChatsCircle;
  const style: React.CSSProperties | undefined = color ? { color } : undefined;

  return (
    <Icon
      {...rest}
      size={size}
      className={className}
      style={style}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    />
  );
};

export default MessagesIcon;
